import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-data-tables-buttons-options',
	templateUrl:'./DataTablesButtonsOptionsPluginCompPage.html',
	styles: [],
	styleUrls:['./DataTablesButtonsOptionsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class DataTablesButtonsOptionsPluginCompPage
{
	mdContent_898 = `\`\`\`java
import com.jwebmp.plugins.datatable.options.buttons.DataTablesButtonsOptions;
\`\`\``;
	mdContent_899 = `\`\`\`java
DataTablesButtonButtonsOptions()
\`\`\``;
	mdContent_900 = `\`\`\`java
DataTableOptions&lt;?&gt; opts = new DataTableOptions&lt;&gt;();
opts.getButtons().add(DataTableButtons.Copy);
opts.getButtons().add(DataTableButtons.Excel);
opts.getButtons().add(DataTableButtons.Pdf);
opts.getButtons().add(DataTableButtons.Csv);
\`\`\``;
}
